import { svc_search, svc_addOne, svc_editOne } from "@/services";
import { message } from "antd";
import "lodash";
import logger from "@/utils/logger";
import { showServerResponse } from "@/utils/message";

const endpointBasePrefix = "payment_types";

const Model = {
	namespace: "m_PaymentType",
	state: {
		paymenttypes: [],
		global: [],
		policy: [],
		scopeToken: {},
	},
	reducers: {
		handleFetchAll(state, { payload: { paymenttypes } }) {
			logger(`** PaymentType reducers response ${JSON.stringify(paymenttypes)}`, 5);
			return { ...state, paymenttypes };
		},
		handleFetchAllGlobal(state, { payload: { global } }) {
			logger(`** PaymentType reducers response ${JSON.stringify(global)}`, 5);
			return { ...state, global };
		},
	},
	effects: {
		*fetchAll({ brandId, outletId, scopeToken }, { call, put }) {
			let paymenttypes = yield call(svc_search, endpointBasePrefix, { brand: brandId, outlet: outletId });
			_.forEach(paymenttypes, function (row) {
				row.key = row.id;
				row.is_taxable = !row.is_taxable;
				row.is_svc_chargeable = !row.is_svc_chargeable;
				row.is_sales = !row.is_sales;
				row.is_deleted = !row.is_deleted;
				if (outletId && !scopeToken.allowedDerivedOutlets.includes(outletId)) row.disableEdit = true;
				if (brandId && !outletId && !scopeToken.allowedBrands.includes(brandId)) row.disableEdit = true;
				row.bc = row.erp_code !== "";
				row.gl = row.gl_code !== "" && row.gl_code !== null;
			});
			
			yield put({
				type: "handleFetchAll",
				payload: { paymenttypes },
			});
		},

		// for xero
		*fetchSelectSearchXREF({ brandId, upos_outlet, scopeToken, payload }, { call, put }) {
			let brand_id = "";
			if (brandId)
				brand_id = brandId;
			if (payload.upos_brand_id)
				brand_id = payload.upos_brand_id;
			let outlet_id = "";
			if (upos_outlet)
				outlet_id = upos_outlet;
			if (payload.upos_outlet_id)
				outlet_id = payload.upos_outlet_id;
			let global = yield call(svc_search, `${endpointBasePrefix}/with_globals`, { brand: brand_id, outlet: outlet_id });

			// remove deleted payment types
			global.result = global.result?.filter((type) => type.is_deleted == 0);
			
			yield put({
				type: "handleFetchAllGlobal",
				payload: { global },
			});
			return global;
		},
		*addPaymentType({ payload }, { call, put }) {
			let newPaymentType = yield call(svc_addOne, endpointBasePrefix, payload);
			logger(("Created Payment Type: ", JSON.stringify(newPaymentType)), 5);
			message.success("Payment Type created.");
		},
		*editPaymentType({ payload }, { call, put }) {
			let newPaymentType = yield call(svc_editOne, endpointBasePrefix, payload, "id");
			logger(("Created Payment Type: ", JSON.stringify(newPaymentType)), 5);
			message.success("Payment Type edited.");
		},
		*reorderPaymentType({ payload }, { call, put }) {
			if (payload && payload.length > 0) {
				const response = yield call(svc_addOne, endpointBasePrefix, payload, "reorder");
				showServerResponse(response);
				return response;
			}
		},
	},
	subscriptions: {
		setup({ dispatch, history }) {
			return history.listen(({ pathname, query }) => {
				if (pathname === "/payment") {
					dispatch({ type: "fetch", payload: query });
				}
			});
		},
	},
};

export default Model;
